export default {
  onboarding: {
    goals: {
      its_2030: 'Se for deg at det er år 2030',
      goals_are_met: `MARKDOWN:Klimamålene er nådd. 
Menneskeheten klarte det!

Vil du vite hvordan?`,
    },
    you: {
      you_matter: 'Fordi DU betyr noe',
      join_the_story:
        'Og nå er du i ferd med å starte den legendariske historien om din påvirkningskraft!',
    },
    compete: {
      compete: 'Konkurrer',
      join_your_team:
        'Bli med på et lag hvor dere sammen takler så mange klima-aktiviteter dere klarer',
    },
    master: {
      master: 'Mestre',
      learn_how:
        'Lær hvordan du kan redusere globale utslipp ved å gjøre små endringer i din livsstil, med mer',
    },
    impact: {
      make_impact: 'Påvirk andre',
      inspire_others:
        'Inspirer andre med historien din og ta påvirkningen din til et helt nytt nivå',
      get_started: 'KOM I GANG',
    },
    skip: 'Hopp over',
  },
  settings: {
    back_to_challenge: 'Tilbake til din utfordring',
    back_to_campaigns: 'Tilbake til dine kampanjer',
    account: 'Konto',
    menu: {
      your_campaigns: 'Dine kampanjer',
      your_profile: 'Profilen din',
      reset_password: 'Endre passord',
      language: 'Språk',
      email_preferences: 'E-postinnstillinger',
      ducky_support: 'Ducky Brukerstøtte',
      privacy_terms: 'Personvern & vilkår',
      log_out: 'Logg ut',
      close: 'Lukk menyen',
    },
    profile: {
      general_info: {
        active_since: 'Aktiv siden %{date}',
        first_name: 'Fornavn',
        last_name: 'Etternavn',
        email: 'E-post',
        save: 'Lagre profil',
        delete_account: 'Slett din konto og alle tilknyttede data',
        delete_everything: 'Slett alt',
        update_picture: 'Oppdater profilbildet ditt',
      },
      delete: {
        delete_account: 'Slett Profil',
        sorry_you_leave:
          'Det er trist at du forlater oss. Vi blir glade om du vil spesifisere hvorfor du forlater oss slik at vi kan forbedre tjenesten.',
        no_longer_need: 'Jeg trenger ikke lengre en konto',
        not_what_expected: 'Tjenesten var ikke så bra som jeg hadde forventet',
        not_working: 'Jeg fikk det ikke til å fungere',
        challenge_ended: 'Utfordringen er uansett over',
        other: 'Annet...',
        please_specify: 'Vennligst spesifiser',
        cannot_reverse: 'Denne handlingen kan ikke reverseres.',
        delete_button: 'Slett Profil',
        type_delete: 'Skriv SLETT for å bekrefte',
      },
    },
    language: 'Språk',
    emails: {
      email_preferences: 'E-postinnstillinger',
      receive_challenge_emails:
        'Jeg vil motta e-poster med statistikk om min utfordring  og andre oppdateringer',
    },
    password: {
      reset_password: 'Endre passord',
      current_password: 'Nåværende passord',
      new_password: 'Nytt passord',
      confirm_password: 'Bekreft passord',
      change_password: 'Endre passord',
    },
    support: {
      ducky_support: 'Ducky Brukerstøtte',
      visit_help_desk:
        'Besøk vår helpdesk for å finne artikler og veiledning om bruk av Ducky. Den inneholder grunnleggende informasjon hvordan man setter opp og gjennomfører en vellykket utfordring',
      browse_articles: 'LES ARTIKLER',
      submit_support_ticket:
        'Hvis du ikke finner det du trenger i noen av artiklene våre, kan sende oss en henvendelse. Ducky-teamet vil håndtere forespørselen din innen to virkedager.',
      create_ticket: 'SEND OSS EN HENVENDELSE',
    },
    privacy: {
      privacy_and_terms: 'Personvern & vilkår',
    },
  },
  ModRegQ6: {
    confirm_your_email: `MARKDOWN:
**Suksess!**

Du må bekrefte e-postadressen din for å fortsette`,
    check_your_inbox: 'Sjekk innboksen din',
    sent_an_email:
      'Vi har sendt deg en e-post med link for å logge deg inn på kontoen din.',
    only_use_once: 'Linken kan bare brukes en gang og utgår etter en time.',
  },
  register: {
    device_message: {
      default:
        'Du trenger ikke noe passord. Bruk en e-post som du enkelt kan åpne på denne enheten, så sender vi deg en magisk lenke.',
      ios_chrome:
        'Vi anbefaler at du bruker Safari og Mail-appen. Men du kan fortsette i Chrome hvis du leser e-post i Gmail-appen på denne enheten.',
      ios_safari:
        'Du trenger ikke noe passord. Bruk en e-post som du kan åpne i Mail-appen på denne enheten.',
    },
  },
  ActSet01: {
    profileText: 'Din Profil',
    bio: 'Bio',
    firstName: 'Fornavn',
    lastName: 'Etternavn',
    saveProfile: 'LAGRE PROFIL',
    active_since: 'Aktiv siden',
  },
  ActSet02: {
    yourAccount: 'Din konto',
    email: 'Epost',
    password: 'Passord',
    changePassword: 'ENDRE PASSORD',
    changePasswordInfo:
      'Vi sender en epost med instruksjoner for å legge til nytt passord.',
    deleteAccount: 'SLETT KONTO',
    deleteAccountInfo: 'Slett din konto og alle tilknyttede data',
  },
  AcSet03: {
    emailAlert: 'Epostvarsel',
    challengeEmailInfo: 'Jeg ønsker å motta e-poster knyttet til utfordringer.',
  },
  TabMen04: {
    profile: 'Profil',
    account: 'Konto',
    settings: 'Innstillinger',
  },
  reset_password: {
    create_new_password: 'Lag et nytt passord til Ducky',
    invalid_code:
      'Denne linken er ikke gyldig, vennligst sørg for å inkludere hele URL i eposten og at du ikke har brukt denne linken tidligere. Be om en ny e-post.',
    no_code_recieved: 'Sørg for å innkludere hele linken fra eposten.',
    submit: 'Sett nytt passord',
    placeholder_password: 'Skriv inn nytt passord',
    placeholder_repeat: 'Gjenta passordet',
    password_has_been_reset: 'Ditt passord har blitt tilbakestilt.',
    go_to_challenge: 'GÅ TIL KLIMAUTFORDRINGEN',
  },
  LaAcc01: {
    been_invited: 'Invitert til å bruke Ducky-verktøyene?',
    select_organisation: 'Velg din organisasjon for å fortsette:',
    you_will_be_registered: 'Du blir registrert med %{organisation}',
    select_section: 'Velg seksjon og lag for å registrere med %{organisation}',
    you_are_registered:
      'Du er registrert som %{organisation}, %{section}, %{team}',
    form: {
      select_organisation: 'Velg organisasjon',
      select_campaign: 'Velg kampanje',
      select_section: 'Velg seksjon',
      select_team: 'Velg lag',
      continue: 'FORTSETT',
      save_and_continue: 'LAGRE OG FORTSETT',
      not_organisation: 'IKKE EN DEL AV EN ORGANISASJON',
    },
  },
  join_campaign: {
    link: {
      title: 'Velkommen til %{campaignName}',
      sub_title: 'Velg %{sectionTerm} og lag for å bli med:',
      sub_title_team_only: 'Velg lag for å bli med:',
    },
    code: {
      title: 'Invitert til en kampanje?',
      title_with_name: 'Velkommen til %{campaignName}',
      sub_title: 'Skriv inn din kode for å bli med:',
      code_placeholder: 'feks. 123456',
      check_code: 'Sjekker...',
      ok: 'OK',
      no_code:
        'Ingen kode? Du kan ha blitt invitert til å delta via en link. Prøv det i stedet!',
    },
    form: {
      choose_campaign: 'Velg din kampanje',
      choose_section: 'Velg din seksjon',
      choose_team: 'Velg ditt lag',
      choose: 'Velg %{sectionTerm}',
      save_and_continue: 'Lagre og fortsett',
    },
    error: {
      title: 'Det skjedde en feil',
      messages: {
        invalid_link:
          'Denne linken er ikke gyldig. Sørg for å få med hele linken.',
        invalid_domain:
          'Epost-domenet ditt kan ikke bli med i denne kampanjen. Sørg for å bruke eposten du har gjennom organisasjonen.',
        joining_error: 'Det skjedde en feil med å bli med på kampanjen',
      },
    },
  },
  timeline: {
    your_challenges: 'Dine utfordringer',
    cant_see:
      'Ser du ikke utfordringen din? Kontakt arrangøren din for å få linken du trenger',
    current: 'PÅGÅENDE KAMPANJER',
    future: 'FREMTIDIGE KAMPANJER',
    past: 'TIDLIGERE KAMPANJER',
    website: 'Nettsiden til %{campaignName}',
    see_more: 'Se mer info og statistikk på nettsiden',
    joined: 'Påmeldt',
    completed: 'Fullført',
    learn_more: 'Lær mer',
    go_to: 'Gå til %{toolName}',
    challenge: {
      co2: {
        heading: 'Klimautfordringen',
        subheading: 'Lær mer',
        text: `MARKDOWN:
Delta i en tre-ukers utfordring på din skole eller arbeidsplass og kutt klimagassutslipp gjennom bærekraftige valg du gjør i hverdagen.

Inspirer teamet ditt ved å gjøre aktiviteter som er miljøvennlige, bra for helsen din og bra for lommeboka.`,
      },
      atWork: {
        heading: 'Utfordringen på jobb',
        subheading: 'Lær mer',
        text: `MARKDOWN:
Delta i en to eller tre-ukers utfordring på din arbeidsplass og kutt klimagassutslipp gjennom bærekraftige valg du gjør i hverdagen.

Inspirer teamet ditt ved å gjøre aktiviteter som er miljøvennlige, bra for helsen din og bra for lommeboka.`,
      },
      workTransport: {
        heading: 'Jobbtransportutfordringen',
        subheading: 'Lær mer',
        text: `MARKDOWN:
Delta i en tre-ukers utfordring på din skole eller arbeidsplass og kutt klimagassutslipp gjennom bærekraftige valg du gjør i hverdagen.

Inspirer teamet ditt ved å gjøre aktiviteter som er miljøvennlige, bra for helsen din og bra for lommeboka.`,
      },
      foodWaste: {
        heading: 'Matsvinnutfordringen',
        subheading: 'Lær mer',
        text: `MARKDOWN:
Delta i en tre-ukers utfordring på din skole eller arbeidsplass og kutt klimagassutslipp gjennom bærekraftige valg du gjør i hverdagen.

Inspirer teamet ditt ved å gjøre aktiviteter som er miljøvennlige, bra for helsen din og bra for lommeboka.`,
      },
      plastic: {
        heading: 'Plastutfordringen',
        subheading: 'Lær mer',
        text: `MARKDOWN:
Delta i en tre-ukers utfordring på din skole eller arbeidsplass og kutt klimagassutslipp gjennom bærekraftige valg du gjør i hverdagen.

Inspirer teamet ditt ved å gjøre aktiviteter som er miljøvennlige, bra for helsen din og bra for lommeboka.`,
      },
      mindfulCitizen: {
        heading: 'Den omsorgsfulle innbygger utfordringen',
        subheading: 'Lær mer',
        text: `MARKDOWN:
Delta i en 2-3 uker lang utfordring hjemme hvor du prøver ut ulike mindfullness aktiviteter sammen med de rundt deg.
  
Inspirer laget ditt ved å gjennomføre aktiviteter som er miljøvennlige og godt for kropp og sjel!

*Den minste gode gjerningen er mer verdt enn de største intensjonene.*
Oscar Wilde`,
      },
    },
  },
};
